const EnvInfo = {
  LOAD_ENVINFO: 'LOAD_ENVINFO',
  LOAD_ENVINFO_SUCCESS: 'LOAD_ENVINFO_SUCCESS',
  LOAD_ENVINFO_FAIL: 'LOAD_ENVINFO_FAIL',
};

export default EnvInfo;
